/* eslint-disable class-methods-use-this */
import React from 'react';
import PropTypes from 'prop-types';
import BaseClass from 'components/BaseClass';
import { wrapComponent } from 'utils/framework';
import Empty from 'constants/empty';
import { Container } from 'components/ui';
import contentConstants from 'constants/content';
import ComponentList from 'components/Content/ComponentList';
import ShopYourStoreBindings from 'analytics/bindingMethods/pages/ShopYourStore/ShopYourStoreBindings';
import helpersUtils from 'utils/Helpers';
const { deferTaskExecution } = helpersUtils;
import { LANDING_PAGE } from 'constants/ShopYourStore';

const { CONTEXTS } = contentConstants;

class ShopMyStoreMain extends BaseClass {
    openStoreSwitcherTimeOut;

    componentDidMount() {
        const {
            isInitialized, isBopisable, hasPreferredStore, showStoreSwitcherModal, showInterstice, fetchShopMyStore
        } = this.props;

        if (!hasPreferredStore) {
            deferTaskExecution(() => {
                showInterstice(true);
            });
            const fn = () => {
                showInterstice(false);
                showStoreSwitcherModal();
            };

            // If a preferred store is not available at page load,
            // wait N seconds before triggering the Store Switcher modal.
            this.openStoreSwitcherTimeOut = setTimeout(fn, LANDING_PAGE.TIMEOUT);
        } else if (!isInitialized) {
            fetchShopMyStore();
        } else if (isInitialized) {
            // Trigger page load tracking for SPA
            ShopYourStoreBindings.shopMyStorePageLoad(isBopisable);
        }
    }

    componentDidUpdate(prevProps) {
        const {
            pageKey, isBopisable, hasPreferredStore, isInitialized, fetchShopMyStore
        } = this.props;

        if (pageKey !== prevProps.pageKey) {
            fetchShopMyStore();
        }

        // If the preferred store becomes available after page load,
        // clear the timeout that would trigger the Store Switcher modal.
        if (!prevProps.hasPreferredStore && hasPreferredStore) {
            clearInterval(this.openStoreSwitcherTimeOut);
        }

        // Trigger page load tracking for full (hard) page load
        if (!prevProps.isInitialized && isInitialized) {
            ShopYourStoreBindings.shopMyStorePageLoad(isBopisable);
        }
    }

    componentWillUnmount() {
        clearInterval(this.openStoreSwitcherTimeOut);
    }

    render() {
        const { isInitialized, content } = this.props;

        if (!isInitialized) {
            return null;
        }

        return (
            <Container
                key='ShopMyStoreMain'
                paddingTop={[4, 5]}
            >
                <ComponentList
                    items={content}
                    context={CONTEXTS.CONTAINER}
                />
            </Container>
        );
    }
}

ShopMyStoreMain.propTypes = {
    isInitialized: PropTypes.bool.isRequired,
    pageKey: PropTypes.string,
    hasPreferredStore: PropTypes.bool,
    showStoreSwitcherModal: PropTypes.func,
    showInterstice: PropTypes.func,
    fetchShopMyStore: PropTypes.func.isRequired
};

ShopMyStoreMain.propTypes = {
    isInitialized: false,
    pageKey: '',
    hasPreferredStore: true,
    showStoreSwitcherModal: Empty.Function,
    showInterstice: Empty.Function,
    fetchShopMyStore: Empty.Function
};

export default wrapComponent(ShopMyStoreMain, 'ShopMyStoreMain', true);
